import { useMonitor } from '../use-monitor';

export function useMonitorManageIssueFormAssign() {
  return useMonitor('manage-issue-form-assign');
}
